export interface Category {
  id: number;
  name: string;
  url: string;
}

export const categories: Category[] = [
  { id: 911, name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { id: 912, name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html' },
  { id: 913, name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html' },
  { id: 914, name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html' },
  { id: 915, name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html' },
  { id: 916, name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html' },
  { id: 917, name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html' },
  { id: 918, name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html' },
  { id: 919, name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html' },
  { id: 920, name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html' },
  { id: 921, name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html' },
  { id: 922, name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html' },
  { id: 923, name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html' },
  { id: 924, name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html' },
];